import request from "@/utils/request";

export function getPagesByCondition(data) {
  return request({
    url: "/person/manage/getPagesByCondition",
    method: "post",
    data: data,
  });
}

export function insert(data) {
  return request({
    url: "/person/manage/save",
    method: "post",
    data: data,
  });
}

export function updateById(data) {
  return request({
    url: "/person/manage/updateById",
    method: "post",
    data: data,
  });
}

export function detailById(id) {
  return request({
    url: `/person/manage/detailById?id=${id}`,
    method: "get",
  });
}

export function checkIdCardNumRepeat(id, idCardNum) {
  let isId = "";
  if (id) {
    isId = id;
  }
  return request({
    url: `/person/manage/checkIdCardNumRepeat?id=${isId}&idCardNum=${idCardNum}`,
    method: "get",
  });
}

export function deleteById(id) {
  return request({
    url: `/person/manage/deleteById?id=${id}`,
    method: "get",
  });
}

export function deleteByBatchId(data) {
  return request({
    url: "/person/manage/deleteByBatchId",
    method: "post",
    data: data,
  });
}

export function carDetailById(id) {
  return request({
    url: `/person/manage/carDetailById?id=${id}`,
    method: "get",
  });
}

export function testTaskDetailById(id) {
  return request({
    url: `/person/manage/testTaskDetailById?id=${id}`,
    method: "get",
  });
}

export function testAccidentRecordDetailById(id) {
  return request({
    url: `/person/manage/testAccidentRecordDetailById?id=${id}`,
    method: "get",
  });
}

export function checkPhoneNumRepeat(id, phoneNum) {
  let isId = "";
  if (id) {
    isId = id;
  }
  return request({
    url: `/person/manage/checkPhoneNumRepeat?id=${isId}&phoneNum=${phoneNum}`,
    method: "get",
  });
}

//测试人员统计
export function personCount () {
  return request({
    url: '/person/manage/count',
    method: 'get'
  })
}